import axios from "axios";

const HolidayService = {
  async getAll() {
    try {
      const response = await axios.get("/Holiday/GetAllHolidays");
      console.log("[Holiday] getAll response:", response.data);
      return response.data;
    } catch (error) {
      console.error("[Holiday] Error fetching holidays:", error);
      throw error;
    }
  },

  // POST with a JSON body, like DGES
  async add(h) {
    try {
      const response = await axios.post("/Holiday/AddHoliday", {
        p_holidayDate: h.date,
        p_holidayName: h.name,
        p_holidayType: h.type,
        p_isActive: h.active ? 1 : 0,
        p_createdBy: h.userId,
        p_remarks: h.remarks || "",
      });
      console.log("[Holiday] add response:", response.data);
      return response.data;
    } catch (error) {
      console.error("[Holiday] Error adding holiday:", error);
      throw error;
    }
  },

  async update(h) {
    try {
      const response = await axios.post("/Holiday/UpdateHoliday", {
        p_holidayId: h.id,
        p_holidayName: h.name,
        p_holidayType: h.type,
        p_holidayDate: h.date,
        p_isActive: h.active ? 1 : 0,
        p_updatedBy: h.userId,
        p_remarks: h.remarks || "",
      });
      console.log("[Holiday] update response:", response.data);
      return response.data;
    } catch (error) {
      console.error("[Holiday] Error updating holiday:", error);
      throw error;
    }
  },

  async remove(id) {
    try {
      const response = await axios.delete(`/Holiday/DeleteHoliday/${encodeURIComponent(id)}`);
      console.log("[Holiday] delete response:", response.data);
      return response.data;
    } catch (error) {
      console.error("[Holiday] Error deleting holiday:", error);
      throw error;
    }
  },
};

export default HolidayService;